import { commonBreakpoints } from '../breakpoints/dist/xsite-ui-common.style-breakpoints.esm.js';
import { m as mixins } from './mixins-b573ed3f.esm.js';

var blue = ['#E6F4FD', '#82C6F3', '#1789D5', '#1564BF'];

var grayscale = ['#F5F5F5', '#E2E2E2', '#D5D5D5', '#999999', '#797979', '#2D2D2D', '#171717', '#000000'];

var green = ['#E1F4F1', '#09A789', '#02826A', '#035D4C'];

var magenta = ['#FFF1F2', '#FF8897', '#FF4A64', '#BC284B'];

var ninja = ['#A3A2C3', '#8E8BB2', '#7A78A8'];

var purple = ['#EDECF3', '#514F8E', '#29256B', '#010233'];

var yellow = ['#FFF6E0', '#FFD266', '#FFB401', '#E59B1B'];

var shadows = ['none', '0px 0px 10px rgba(0,0,0,0.25)', '0px 4px 10px rgba(6, 0, 117, 0.15)'];

var space = [0, 4, 8, 12, 16, 20, 24, 32, 36, 40, 52, 72];

var colors = {
  blue: blue,
  green: green,
  grayscale: grayscale,
  magenta: magenta,
  purple: purple,
  yellow: yellow,
  ninja: ninja
};

var fontSize = [12, 14, 16, 20, 24, 32, 48, 64];
fontSize.sm = fontSize[0];
fontSize.body = fontSize[1];
fontSize.md = fontSize[2];
fontSize.lg = fontSize[3];
fontSize.xl = fontSize[6];
fontSize.h1 = fontSize[5];
fontSize.h2 = fontSize[4];
fontSize.h3 = fontSize[3];
fontSize.h4 = fontSize[2];

var fontWeights = [400, 600, 700];
fontWeights.base = fontWeights[0];
fontWeights.body = fontWeights[0];
fontWeights.semiBold = fontWeights[1];
fontWeights.bold = fontWeights[2];
fontWeights.heading = fontWeights[2];

var fonts = {
  body: 'hurmegeometricsans_no3_6, Gilroy, Arial, sans-serif',
  heading: 'inherit',
  monospace: 'Menlo, monospace'
};

var avatarColors = [colors.blue[3], colors.yellow[3], colors.green[3], colors.magenta[3]]; // aliases

avatarColors.primary = colors.blue[3];
avatarColors.blue = colors.blue[3];
avatarColors.yellow = colors.yellow[3];
avatarColors.green = colors.green[3];
avatarColors.magenta = colors.magenta[3];
var avatar = {
  color: avatarColors
};

var breadcrumbs = {
  primary: {
    backgroundColor: 'unset',
    fontColor: colors === null || colors === void 0 ? void 0 : colors.grayscale[4],
    hoverColor: colors === null || colors === void 0 ? void 0 : colors.grayscale[5],
    fontWeight: 'unset'
  },
  secondary: {
    backgroundColor: colors === null || colors === void 0 ? void 0 : colors.purple[2],
    fontColor: colors === null || colors === void 0 ? void 0 : colors.ninja[0],
    hoverColor: colors === null || colors === void 0 ? void 0 : colors.ninja[0],
    fontWeight: 'bold'
  }
};

var button = {
  ghost: {
    primary: {
      color: colors.magenta[2],
      '&:hover': {
        color: colors.magenta[3]
      }
    },
    secondary: {
      color: colors.blue[2],
      '&:hover': {
        color: colors.blue[3]
      }
    }
  },
  contained: {
    primary: {
      backgroundColor: colors.magenta[2],
      color: 'white',
      border: '1px solid white',
      transition: 'background-color 0.3s',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: colors.magenta[3]
      },
      '&:disabled': {
        pointerEvents: 'none',
        backgroundColor: colors.grayscale[1]
      },
      active: {
        backgroundColor: colors.magenta[3]
      },
      icon: {
        endIcon: {
          fontSize: fontSize[0],
          marginTop: '2px'
        }
      }
    },
    secondary: {
      backgroundColor: colors.grayscale[0],
      color: 'black',
      border: '1px solid white',
      transition: 'background-color 0.3s',
      '&:hover': {
        backgroundColor: colors.grayscale[1]
      },
      active: {
        backgroundColor: 'rgba(255, 74, 100, 0.2)',
        color: 'black',
        '&:hover': {
          backgroundColor: 'rgba(255, 74, 100, 0.3)'
        }
      },
      icon: {
        startIcon: {
          height: fontSize.h2,
          width: fontSize.h2,
          color: colors.magenta[2]
        },
        endIcon: {
          fontSize: fontSize[0],
          marginTop: '2px'
        }
      }
    },
    yellow: {
      backgroundColor: colors.yellow[2],
      color: colors.grayscale[5],
      transition: 'background-color 0.3s',
      '&:hover': {
        backgroundColor: colors.yellow[3]
      },
      '&:disabled': {
        pointerEvents: 'none',
        backgroundColor: colors.grayscale[1]
      },
      icon: {
        endIcon: {
          fontSize: fontSize[0],
          marginTop: '2px'
        }
      }
    }
  },
  outlined: {
    primary: {
      backgroundColor: 'white',
      color: colors.magenta[3],
      border: "1px solid ".concat(colors.magenta[3]),
      transition: 'background-color 0.3s, color 0.3s',
      '&:hover': {
        backgroundColor: colors.magenta[3],
        color: 'white'
      },
      '&:disabled': {
        pointerEvents: 'none',
        backgroundColor: '#fff',
        color: colors.grayscale[1],
        border: "1px solid ".concat(colors.grayscale[1])
      }
    },
    secondary: {
      backgroundColor: 'white',
      color: colors.magenta[3],
      border: "1px solid ".concat(colors.magenta[3]),
      transition: 'background-color 0.3s, color 0.3s',
      '&:hover': {
        backgroundColor: colors.magenta[3],
        color: 'white'
      }
    },
    info: {
      backgroundColor: 'white',
      color: colors.blue[2],
      border: "1px solid ".concat(colors.blue[2]),
      transition: 'all 0.3s',
      '&:hover': {
        backgroundColor: colors.blue[0]
      }
    }
  },
  small: {
    padding: "".concat(space[1], "px ").concat(space[5], "px"),
    fontSize: "".concat(fontSize.md, "px"),
    height: "".concat(space[6], "px")
  },
  large: {
    padding: "".concat(space[3], "px ").concat(space[5], "px"),
    fontSize: "".concat(fontSize.md, "px"),
    height: "".concat(space[9], "px")
  },
  borderRadius: space[1],
  fontWeight: fontWeights.semiBold
};

var progressBar = {
  primary: {
    progressBarWrapper: {
      borderRadius: "".concat(space[3] * 5, "px")
    },
    barWrapper: {
      background: colors.grayscale[0]
    },
    progressWrapper: {
      background: colors.blue[2]
    }
  },
  secondary: {
    progressBarWrapper: {
      borderRadius: "".concat(space[3] * 5, "px")
    },
    barWrapper: {
      background: colors.grayscale[0]
    },
    progressWrapper: {
      background: colors.magenta[3]
    }
  },
  small: {
    height: space[2]
  },
  medium: {
    height: space[5]
  },
  large: {
    height: space[9]
  }
};

var ratingStars = {
  fill: colors.yellow[2],
  background: colors.grayscale[2]
}; // import colors from '../colors';
// import { Theme } from '../theme';
//
// export default (theme: Theme) => ({
//   fill: theme.colors.yellow[2],
//   background: theme.colors.grayscale[2],
// });

var variants = {
  ratingStars: ratingStars,
  avatar: avatar,
  button: button,
  progressBar: progressBar,
  breadcrumbs: breadcrumbs
};

var theme = {
  breakpoints: commonBreakpoints,
  colors: colors,
  fonts: fonts,
  fontSizes: fontSize,
  fontWeights: fontWeights,
  mixins: mixins,
  shadows: shadows,
  space: space,
  variants: variants,
  name: 'default'
};

export { fonts as a, fontWeights as b, blue as c, green as d, space as e, fontSize as f, grayscale as g, magenta as m, ninja as n, purple as p, shadows as s, theme as t, variants as v, yellow as y };
